/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type TherapyDtoTherapyResult = (typeof TherapyDtoTherapyResult)[keyof typeof TherapyDtoTherapyResult];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TherapyDtoTherapyResult = {
  PENDING: 'PENDING',
  HEALED_LUNG_TB: 'HEALED_LUNG_TB',
  THERAPY_COMPLETED: 'THERAPY_COMPLETED',
  THERAPY_FAILED_CLINICAL_TEST: 'THERAPY_FAILED_CLINICAL_TEST',
  THERAPY_FAILED_MEDICATION_SIDE_EFFECTS: 'THERAPY_FAILED_MEDICATION_SIDE_EFFECTS',
  THERAPY_FAILED_LABORATORY_RESISTANCE: 'THERAPY_FAILED_LABORATORY_RESISTANCE',
  DEATH: 'DEATH',
  THERAPY_INTERRUPTION: 'THERAPY_INTERRUPTION',
  REFERRAL: 'REFERRAL',
  THERAPY_UNKNOWN_RESULT: 'THERAPY_UNKNOWN_RESULT',
  NO_TB: 'NO_TB',
} as const;
